import When from "./When";

const SubmitButton = ({
  children,
  isLoading = false,
  disabled = false,
  bgColor = "bg-orange-600",
  padding = 0,
  buttonClass = "",
  childrenClass = "",
  onPress,
}: {
  children: JSX.Element | string;
  isLoading?: boolean;
  disabled?: boolean;
  bgColor?: string;
  padding?: number;
  buttonClass?: string;
  childrenClass?: string;
  onPress?: any;
}) => {
  return (
    <button
      type="submit"
      disabled={isLoading || disabled}
      className={`rounded-full transform hover:scale-103 shadow-lg text-lg motion-reduce:transform-none disabled:opacity-75 inline-flex items-center py-${padding} px-4 text-white ${buttonClass}`}
      onClick={() => {
        if (onPress) {
          onPress();
        }
      }}
      style={{ backgroundColor: `${bgColor}` }}
    >
      <div className={`flex items-center ${childrenClass}`}>
        <When isTrue={isLoading}>
          <div className="mr-2">
            <svg
              className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
          </div>
        </When>
        {children}
      </div>
    </button>
  );
};

export default SubmitButton;
